
import { PartnerAPI } from '@/api';
import {
  defineComponent,
  PropType,
  ref,
  onMounted, reactive,
} from 'vue';
import PartnerInterface from '@/interfaces/PartnerInterface';
import Modal from '@/components/Modal.vue';
import InputField from '@/components/InputField.vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
    Modal,
    InputField,
  },

  props: {
    partner: {
      type: Object as PropType<PartnerInterface>,
      required: false,
      default: () => null,
    },
  },

  emits: ['valid'],

  setup(props, { emit }) {
    const modal = ref<InstanceType<typeof Modal>>();
    const router = useRouter();
    const form = reactive({
      code: null as string | null,
    });
    const errors = reactive({ value: {} as Record<string, string | string[]> });
    const isLoading = ref(false);

    const redirectToHome = () => {
      router.push({ path: '/' });
    };

    const submit = () => {
      isLoading.value = true;
      PartnerAPI.isValid(props.partner.id as string, form.code).then(() => {
        if (modal.value) {
          modal.value.close();
        }
        setTimeout(() => {
          emit('valid', true);
        }, 680);
      }).catch(() => {
        errors.value.code = 'Code ungültig.';
      }).finally(() => {
        isLoading.value = false;
      });
    };

    onMounted(() => {
      if (modal.value) {
        modal.value.open();
      }
    });

    return {
      modal,
      form,
      errors,
      isLoading,
      redirectToHome,
      submit,
    };
  },
});
